import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AddBoxIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5ZM5 4.16667C4.53976 4.16667 4.16667 4.53976 4.16667 5V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H15C15.4602 15.8333 15.8333 15.4602 15.8333 15V5C15.8333 4.53976 15.4602 4.16667 15 4.16667H5ZM10 6.66667C10.4602 6.66667 10.8333 7.03976 10.8333 7.5V9.16667H12.5C12.9602 9.16667 13.3333 9.53976 13.3333 10C13.3333 10.4602 12.9602 10.8333 12.5 10.8333H10.8333V12.5C10.8333 12.9602 10.4602 13.3333 10 13.3333C9.53976 13.3333 9.16667 12.9602 9.16667 12.5V10.8333H7.5C7.03976 10.8333 6.66667 10.4602 6.66667 10C6.66667 9.53976 7.03976 9.16667 7.5 9.16667H9.16667V7.5C9.16667 7.03976 9.53976 6.66667 10 6.66667Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

AddBoxIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AddBoxIcon);
